import {ProjectNs} from "@shared/types";
import {useSelectedProjectStore} from "@domains/boards/stores/selected-project.store";
import {useWorkspaceStore} from "@shared/stores/workspace.store";

export function isWsOwnerOrAdmin() {
    const workspaceStore = useWorkspaceStore();
    return ['ADMIN', 'OWNER'].includes(workspaceStore.getWorkspaceRole);
}

export function isProjectManager() {
    const editorStore = useSelectedProjectStore();
    return isWsOwnerOrAdmin() || ProjectNs.ProjectRoleEnums.MANAGER === editorStore.getSelectedProjectRole as any;
}

export function isProjectEditor() {
    const editorStore = useSelectedProjectStore();
    return isWsOwnerOrAdmin() || [ProjectNs.ProjectRoleEnums.MANAGER, ProjectNs.ProjectRoleEnums.EDITOR].includes(editorStore.getSelectedProjectRole as any);
}

export function canAccess(...roles: ProjectNs.ProjectRoleEnums[]) {
    const editorStore = useSelectedProjectStore();
    const userRole: ProjectNs.ProjectRoleEnums = editorStore.getSelectedProjectRole
    return roles.includes(userRole)
}
